<script lang="ts">
  import type { BoxComponentProps } from './types';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  type $$Props = BoxComponentProps;

  export let entryId: BoxComponentProps['entryId'];
  export let content: BoxComponentProps['content'];
  export let hasContentClass: BoxComponentProps['hasContentClass'];
  export let topLevelElement: BoxComponentProps['topLevelElement'];
  export let linkId: BoxComponentProps['linkId'] = undefined;
  export let url: BoxComponentProps['url'] = undefined;
  export let customCssClass: BoxComponentProps['customCssClass'];
</script>

<svelte:element
  this={topLevelElement}
  class="BoxComponent BoxComponent-{entryId}-box-properties {customCssClass}"
  data-has-link={url ? 'true' : 'false'}
  data-entry-id={entryId}
  class:content={hasContentClass}
  id={linkId}
>
  {#if url}
    <a href={url} tabindex="-1" aria-hidden="true">
      <!-- This link will be positioned over the full BoxComponent, does not need content inside the anchor
          Avoids the nested anchor issue: https://github.com/sveltejs/kit/issues/10990
      -->
    </a>
  {/if}
  {#if content}
    <DynamicChildrenComponent children={content} />
  {/if}
</svelte:element>

<style lang="scss">
  .BoxComponent {
    border-style: solid;
    border-color: var(--border-color);

    &[data-has-link='true'] {
      cursor: pointer;
      position: relative;

      a {
        position: static !important;

        &::after {
          content: ' ';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }

    &.content {
      :global(.content) {
        width: 100%;
      }
    }
  }

  a.BoxComponent {
    display: block;
    text-decoration: none;
  }

  :global {
    // hotfix until box-properties support "flex" display
    .sq-custom-display-flex {
      display: flex !important;
    }
  }
</style>
